import PicabooConstants, { SECTION_TYPES } from '../common/PicabooConstants';

export default function (leftPageID, sections, paperTypeID) {
  if (sections) {
    let spreadIndex = 0;
    let pageIndex = 0;
    for (let arr of sections) {
      let sectionID = arr[0];
      let s = arr[1];
      if (s) {
        if (
          s.get('type') == SECTION_TYPES.TYPE_COVER ||
          s.get('type') == SECTION_TYPES.TYPE_SOFTCOVER ||
          s.get('type') == SECTION_TYPES.TYPE_INDEX
        ) {
          continue;
        }
        s.get('spreads').map((spread, index) => {
          if (
            spread
              .get('pages')
              .toJS()
              .some((page) => {
                return page.pageID == leftPageID;
              })
          ) {
            spreadIndex = pageIndex;
          }
          ++pageIndex;
        });
      }
    }

    return spreadIndex * 2 + 1;
  }

  return 0;
}
